
import { IAnswerRepository } from './IAnswerRepository';
import { AnswerMergedResponse } from './AnswerTypes';
import { AnswerService , DailyPerformanceService , DailyPerformanceRecord } from '@PikaDoApp/npm-pikado-logic';
export class AnswerRepository implements IAnswerRepository {
  private answerService: AnswerService;
  private dailyPerformanceService: DailyPerformanceService;

  constructor() {
    this.answerService = new AnswerService();
    this.dailyPerformanceService = new DailyPerformanceService()
  }

    async getAnswer(id: string): Promise<AnswerMergedResponse> {
    const response = await this.answerService.getAnswer(id);
    return response;
  }
    async getDailyPerformanceById(id: string): Promise<DailyPerformanceRecord> {
    const response = await this.dailyPerformanceService.getById(id);
    return response;
  }
}
